import { TimelineCheckpoint } from "./Timeline";
import { toLocaleDateString } from "../../utils/helpers";
import * as translator from "../../utils/translator";
import { ORDER_FLOWS, ALTERNATIVE_TREATMENT_OFFERED } from "../../utils/consts";

// time formatting
const date_options = {
  month: "short",
  day: "numeric",
};

export const myAccountTimelineCheckpointsCreator = (
  orderData: any,
  language: string
): TimelineCheckpoint[] => {
  let doctorReviewdAt = "";
  let isRejected = false;
  const pharmacyReviewdAt = orderData.pharmacyRejectedAt
    ? orderData.pharmacyRejectedAt
    : orderData.pharmacyApprovedAt;
  const isPharmacyRejected = orderData.pharmacyRejectedAt ? true : false;
  if (orderData.orderPrescription) {
    doctorReviewdAt = orderData.orderPrescription.rejected_at
      ? orderData.orderPrescription.rejected_at
      : orderData.orderPrescription.approved_at;
    isRejected = Boolean(orderData.orderPrescription.rejected_at);
  }
  const isAlternativeOffered = orderData.status === ALTERNATIVE_TREATMENT_OFFERED;
  // When patient accepts the doctor's alternative, the order is auto-approved — does not return to the doctor.
  const isAlternativeAccepted = Boolean(orderData.doctorAlternativeAccepted);
  const isAlternativeRejected = Boolean(orderData.doctorAlternativeRejected);
  const checkpointDates = orderData.checkpointDates;
  
  if (!checkpointDates) return [];

  if (orderData.isProbatixOrder) {
    const status = orderData.status;
    const statusOrder = ['sent_to_pharmacy', 'sent_to_customer', 'kit_activated', 'sample_in_lab', 'delivered'];
    const currentStepIndex = statusOrder.indexOf(status);

    return [
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/test_kit_order_confirmed`
        ),
        date: toLocaleDateString(checkpointDates[0], language, date_options),
        isToggled: currentStepIndex >= 0,
        index: 1,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/test_kit_kit_shipped`
        ),
        date: toLocaleDateString(checkpointDates[1], language, date_options),
        isToggled: currentStepIndex >= 1,
        index: 2,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/test_kit_kit_activated`
        ),
        date: toLocaleDateString(checkpointDates[2], language, date_options),
        isToggled: currentStepIndex >= 2,
        index: 3,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/test_kit_sample_in_lab`
        ),
        date: toLocaleDateString(checkpointDates[3], language, date_options),
        isToggled: currentStepIndex >= 3,
        index: 4,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/test_kit_results_ready`
        ),
        date: toLocaleDateString(checkpointDates[4], language, date_options),
        isToggled: currentStepIndex >= 4,
        index: 5,
      },
    ];
  }

  if (orderData.isCannabisOrder && orderData.orderType == "prescription_only") {
    return [
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/created`
        ),
        date: toLocaleDateString(checkpointDates[0], language, date_options),
        isToggled: orderData.createdAt,
        index: 1,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/paid`
        ),
        date: toLocaleDateString(checkpointDates[1], language, date_options),
        isToggled: orderData.paidAt,
        index: 2,
      },
      {
        title: isAlternativeOffered
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_offered`
            )
          : isAlternativeAccepted
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_accepted`
            )
          : isAlternativeRejected
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_rejected`
            )
          : !isRejected
          ? translator.translate(
              language,
              "my_account",
              orderData.hasPharmacyOnlyMedicine
                ? `MyOrders/details/timelineStatus/order_confirmed`
                : `MyOrders/details/timelineStatus/prescription_confirmed`
            )
          : translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/prescription_rejected`
            ),
        date: toLocaleDateString(checkpointDates[2], language, date_options),
        isToggled: Boolean(doctorReviewdAt) || isAlternativeOffered || isAlternativeAccepted || isAlternativeRejected,
        index: 3,
        danger: (Boolean(isRejected) && Boolean(doctorReviewdAt)) || isAlternativeRejected,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/accepted_by_pharmacy`
        ),
        date: toLocaleDateString(checkpointDates[3], language, date_options),
        isToggled: !Boolean(isPharmacyRejected) && Boolean(pharmacyReviewdAt),
        index: 4,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/delivered`
        ),
        date: toLocaleDateString(checkpointDates[4], language, date_options),
        isToggled: orderData.deliveredAt,
        index: 5,
      },
    ];
  } else if (orderData.flow === ORDER_FLOWS.SCHENGEN) {

    return [
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/created`
        ),
        date: toLocaleDateString(checkpointDates[0], language, date_options),
        isToggled: orderData.createdAt,
        index: 1,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/paid`
        ),
        date: toLocaleDateString(checkpointDates[1], language, date_options),
        isToggled: orderData.paidAt,
        index: 2,
      },
      {
        title: translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/schengen_attachment_created`
            ),
          
        date: toLocaleDateString(checkpointDates[2], language, date_options),
        isToggled: orderData.sentAt,
        index: 3,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/sent_to_customer`
        ),
        date: toLocaleDateString(checkpointDates[3], language, date_options),
        isToggled: orderData.sentAt,
        index: 4,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/delivered`
        ),
        date: toLocaleDateString(checkpointDates[4], language, date_options),
        isToggled: orderData.deliveredAt,
        index: 5,
      },
    ];
  } else if (orderData.orderType == "prescription_only") {
    return [
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/created`
        ),
        date: toLocaleDateString(checkpointDates[0], language, date_options),
        isToggled: orderData.createdAt,
        index: 1,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/paid`
        ),
        date: toLocaleDateString(checkpointDates[1], language, date_options),
        isToggled: orderData.paidAt,
        index: 2,
      },
      {
        title: isAlternativeOffered
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_offered`
            )
          : isAlternativeAccepted
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_accepted`
            )
          : isAlternativeRejected
          ? translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/alternative_treatment_rejected`
            )
          : !isRejected
          ? translator.translate(
              language,
              "my_account",
              orderData.hasPharmacyOnlyMedicine
                ? `MyOrders/details/timelineStatus/order_confirmed`
                : `MyOrders/details/timelineStatus/prescription_confirmed`
            )
          : translator.translate(
              language,
              "my_account",
              `MyOrders/details/timelineStatus/prescription_rejected`
            ),
        date: toLocaleDateString(checkpointDates[2], language, date_options),
        isToggled: Boolean(doctorReviewdAt) || isAlternativeOffered || isAlternativeAccepted || isAlternativeRejected,
        index: 3,
        danger: (Boolean(isRejected) && Boolean(doctorReviewdAt)) || isAlternativeRejected,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/sent_to_customer`
        ),
        date: toLocaleDateString(checkpointDates[3], language, date_options),
        isToggled: orderData.sentAt,
        index: 4,
      },
      {
        title: translator.translate(
          language,
          "my_account",
          `MyOrders/details/timelineStatus/delivered`
        ),
        date: toLocaleDateString(checkpointDates[4], language, date_options),
        isToggled: orderData.deliveredAt,
        index: 5,
      },
    ];
  }
  return [
    {
      title: translator.translate(
        language,
        "my_account",
        `MyOrders/details/timelineStatus/created`
      ),
      date: toLocaleDateString(checkpointDates[0], language, date_options),
      isToggled: orderData.createdAt,
      index: 1,
    },
    {
      title: translator.translate(
        language,
        "my_account",
        `MyOrders/details/timelineStatus/paid`
      ),
      date: toLocaleDateString(checkpointDates[1], language, date_options),
      isToggled: orderData.paidAt,
      index: 2,
    },
    {
      title: isAlternativeOffered
        ? translator.translate(
            language,
            "my_account",
            `MyOrders/details/timelineStatus/alternative_treatment_offered`
          )
        : isAlternativeAccepted
        ? translator.translate(
            language,
            "my_account",
            `MyOrders/details/timelineStatus/alternative_treatment_accepted`
          )
        : isAlternativeRejected
        ? translator.translate(
            language,
            "my_account",
            `MyOrders/details/timelineStatus/alternative_treatment_rejected`
          )
        : !isRejected
        ? translator.translate(
            language,
            "my_account",
            orderData.hasPharmacyOnlyMedicine
              ? `MyOrders/details/timelineStatus/order_confirmed`
              : `MyOrders/details/timelineStatus/prescription_confirmed`
          )
        : translator.translate(
            language,
            "my_account",
            `MyOrders/details/timelineStatus/prescription_rejected`
          ),
      date: toLocaleDateString(checkpointDates[2], language, date_options),
      isToggled: Boolean(doctorReviewdAt) || isAlternativeOffered || isAlternativeAccepted || isAlternativeRejected,
      index: 3,
      danger: (Boolean(isRejected) && Boolean(doctorReviewdAt)) || isAlternativeRejected,
    },
    {
      title: translator.translate(
        language,
        "my_account",
        `MyOrders/details/timelineStatus/sent_to_pharmacy`
      ),
      date: toLocaleDateString(checkpointDates[3], language, date_options),
      isToggled: orderData.sentToPharmacyAt,
      index: 4,
    },
    {
      title: translator.translate(
        language,
        "my_account",
        `MyOrders/details/timelineStatus/sent_to_customer`
      ),
      date: toLocaleDateString(checkpointDates[4], language, date_options),
      isToggled: orderData.sentAt,
      index: 5,
    },
    {
      title: translator.translate(
        language,
        "my_account",
        `MyOrders/details/timelineStatus/delivered`
      ),
      date: toLocaleDateString(checkpointDates[5], language, date_options),
      isToggled: orderData.deliveredAt,
      index: 6,
    },
  ];
};
